<script setup lang="ts">
import CircleNotSelectedIcon from '~/components/icons/CircleNotSelectedIcon.vue'

defineOptions({
	name: 'HeaderNumber',
})

interface Props {
	value?: string | number | null
	isYellowBall?: boolean
	isEmpty?: boolean
	showBtnClear?: boolean
	classContainer?: string
	classIconNotSelect?: string
}

const props = withDefaults(defineProps<Props>(), {
	value: null,
	isYellowBall: false,
	isEmpty: false,
	showBtnClear: true,
	classContainer: 'size-12 sm:size-14 text-sm',
	classIconNotSelect: 'w-12 sm:w-14',
})

const emit = defineEmits(['clear'])

const handleClear = () => {
	if (props.value !== null && !props.isEmpty) {
		emit('clear')
	}
}
</script>

<template>
	<div
		class="relative"
		:data-value="value"
	>
		<!-- Botón de limpiar -->
		<Transition name="bounce">
			<button
				v-if="showBtnClear && value !== null && !isEmpty"
				class="border-2 border-[#E30000] rounded-full bg-[#D9D9D9] size-6 absolute -top-0.5 -right-1.5 flex justify-center items-center hover:scale-110 transition-transform z-10"
				@click="handleClear"
			>
				<UIcon
					name="i-heroicons-x-mark-20-solid"
					class="text-[#E30000]"
				/>
			</button>
		</Transition>
		<div
			:class="[
				'rounded-full flex items-center justify-center text-white font-semibold',
				'transition-all duration-300 cursor-pointer relative',
				{
					// Bolita con valor - con borde y overflow hidden
					'bg-yellow-300 text-secondary-900': isYellowBall && value !== null && !isEmpty,
					'bg-white text-secondary-900': !isYellowBall && value !== null && !isEmpty,

					// Bolita vacía - sin borde y sin overflow hidden para que se vea la estrella
					'bg-transparent': value === null || isEmpty,
				},
				classContainer,
			]"
			@click="handleClear"
		>
			<!-- Contenido sin animación -->
			<div
				v-if="value !== null && !isEmpty"
				class="absolute inset-0 flex items-center justify-center text-secondary-900"
			>
				{{ value }}
			</div>

			<!-- Bolita vacía con ícono SVG -->
			<div
				v-else
				class="absolute inset-0 flex items-center justify-center"
			>
				<div
					class="relative inset-0 flex items-center justify-center"
					:class="isYellowBall ? 'text-yellow-300' : 'text-neutral-50'"
				>
					<CircleNotSelectedIcon :class="classIconNotSelect" />
					<div class="absolute">?</div>
				</div>

				<UIcon
					v-if="isYellowBall"
					name="i-material-symbols:star-rate"
					class="text-yellow-400 absolute -right-[5px] top-[42%]"
				/>
			</div>
		</div>
	</div>
</template>

<style scoped>
.bounce-enter-active {
	animation: bounce 0.7s;
}

@keyframes bounce {
	0% {
		opacity: 0;
		transform: translateX(-120%);
	}
	40% {
		opacity: 1;
		transform: translateX(0);
	}
	50% {
		transform: translateX(0);
	}
	75% {
		transform: translateX(0);
	}
	90% {
		transform: translateX(0);
	}
}
</style>
